export default "__VITE_ASSET__6N2O36mr__"